import { useCallback } from 'react';
import { useSpecialPricingRuleDeleteMutation } from 'api';
import { notification } from 'components';
import { ErrorMappingValueType } from 'typings';

export const useDeleteModal = (onDeleteModalClose: () => void) => {
  const [notificationApi, contextHolder] = notification.useNotification();
  const [specialPricingRuleDelete, { isLoading }] = useSpecialPricingRuleDeleteMutation();
  const openNotificationWithIcon = useCallback(
    (messageContent: ErrorMappingValueType) => {
      const { type, message } = messageContent;
      notificationApi[type]({ message: message });
    },
    [notificationApi]
  );

  const onRemoveConfirm = useCallback(
    async (specialPricingRule: { id: string | undefined }) => {
      try {
        const { data, error }: any = await specialPricingRuleDelete({
          id: specialPricingRule.id,
        });
        if (data?.success) {
          openNotificationWithIcon({
            type: 'success',
            message: `The Special Pricing Rule was successfully deleted.`,
          });
          onDeleteModalClose();
        } else if (error?.data?.success === false) {
          const { data = {} } = error.data;
          Object.keys(data).forEach((_key: string) => {
            openNotificationWithIcon({
              type: 'error',
              message: data[_key],
            });
          });
        } else {
          openNotificationWithIcon({
            type: 'error',
            message: error?.data?.error || 'Something went wrong!',
          });
        }
      } catch (err) {
        console.error('Error deleting Special Pricing Rule:', err);
        openNotificationWithIcon({
          type: 'error',
          message: 'An unexpected error occurred!',
        });
      }
    },
    [specialPricingRuleDelete, openNotificationWithIcon, onDeleteModalClose]
  );

  return {
    onRemoveConfirm,
    contextHolder,
    isLoading,
  };
};
